import {useQuery} from 'react-query';
import {getListLoanRule} from './getListLoanRule';

const useGetListLoanRule = (loanRequestGuid?: string, enabled?: boolean) => {
  const {data, isLoading} = useQuery({
    queryKey: ['get-list-loan-request', loanRequestGuid],
    queryFn: () => getListLoanRule(loanRequestGuid as string),
    enabled: enabled && Boolean(loanRequestGuid),
  });

  return {loanRule: data, isLoadingLoanRule: isLoading};
};

export default useGetListLoanRule;
